import makeStyles from '@material-ui/core/styles/makeStyles';
import ImageDisplay from '../ImageDisplay';
import ConfirmCard from './ConfirmCard';

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      minHeight: 52,
      marginBottom: 12,
    },
  }),
  { name: 'ConfirmCardPreview' },
);

function ConfirmCardPreview({ orgIconURL, message }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ImageDisplay
        style={{ objectFit: 'contain', borderRadius: '50%', marginRight: 12 }}
        src={orgIconURL}
        width={44}
        height={44}
      />
      <ConfirmCard elements={message.data.elements} />
    </div>
  );
}

export default ConfirmCardPreview;
